import React, { useEffect } from 'react';
import { useRouteError, useNavigate } from 'react-router-dom';
import { Box, Button, Typography, Container, Paper } from '@mui/material';
import ReloadOutlined from '@ant-design/icons/ReloadOutlined';
import HomeOutlined from '@ant-design/icons/HomeOutlined';

export default function RouteErrorBoundary() {
  const error = useRouteError();
  const navigate = useNavigate();

  const errorMessage = error?.message || error?.statusText || (typeof error === 'string' ? error : '');
  const isChunkError =
    errorMessage.includes('Failed to fetch dynamically imported module') ||
    errorMessage.includes('Importing a module script failed') ||
    errorMessage.includes('error loading dynamically imported module') ||
    error?.name === 'ChunkLoadError';

  useEffect(() => {
    if (isChunkError) {
      const reloadKey = 'chunk_reload_' + window.location.pathname;
      if (!sessionStorage.getItem(reloadKey)) {
        sessionStorage.setItem(reloadKey, 'true');
        window.location.reload();
      }
    }
  }, [isChunkError]);

  const handleReload = () => {
    sessionStorage.removeItem('chunk_reload_' + window.location.pathname);
    window.location.reload();
  };

  return (
    <Container maxWidth="sm" sx={{ py: 8, display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '60vh' }}>
      <Paper elevation={3} sx={{ p: 4, textAlign: 'center', width: '100%', borderRadius: 2 }}>
        <Typography variant="h4" color="primary" sx={{ fontWeight: 600, mb: 1 }}>
          {isChunkError ? 'Application Update Available' : 'Something went wrong'}
        </Typography>
        <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
          {isChunkError
            ? 'A newer version of the application has been deployed. Please reload the page to load the latest changes.'
            : errorMessage || 'An unexpected error occurred while loading this page.'}
        </Typography>
        <Box sx={{ display: 'flex', gap: 2, justifyContent: 'center', flexWrap: 'wrap' }}>
          <Button variant="contained" color="primary" startIcon={<ReloadOutlined />} onClick={handleReload}>
            Reload Page
          </Button>
          {!isChunkError && (
            <Button variant="outlined" startIcon={<HomeOutlined />} onClick={() => navigate('/')}>
              Go to Dashboard
            </Button>
          )}
        </Box>
      </Paper>
    </Container>
  );
}
